// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingDots_root__fhl0Y","inner":"LoadingDots_inner__piP_N","blink":"LoadingDots_blink__KuINI"};